import { Flex } from '@smarterservices/smarter-ui';

import UserDetails from './User';
import CourseDetails from './CourseDetails';
import ExamDetails from './Exam';
import ProctorNotes from './ProctorNotes';
import StudentNotes from './StudentNotes';
import PermittedItems from './PermittedItems';
import ModalityOptions from './ModalityOptions';
import { useAppStore } from '../../../stores/StoreContext';
const SessionInfo = () => {
  const attachedToProctorRoomSid = useAppStore(state => state.attachedToProctorRoomSid);

  return (
    <Flex>
      <Flex.Item
        as="div"
        width="35%"
        align="start"
        padding="none small none none"
      >
        {/* This is not needed for playback or R&R because it is serviced in another location... */}
        {attachedToProctorRoomSid &&
          <CourseDetails background="secondary" margin="none none small none" />
        }
        <ModalityOptions background="secondary" />
      </Flex.Item>
      <Flex.Item as="div" shouldGrow width="65%" align="start">
        <ExamDetails background="secondary" margin="none none small none" />
        <ProctorNotes background="secondary" margin="none none small none" />
        <PermittedItems background="secondary" margin="none none small none" />
        <StudentNotes background="secondary" />
      </Flex.Item>
    </Flex>
  );
};

export default SessionInfo;
